import React, { useState } from "react"
import { Grid } from "components/grid/styles"
import data from "content/all-access-categories.json"
import { graphql, useStaticQuery } from "gatsby"
import groupClasses from "utils/groupClasses"
import { HeadingContent, MainContainer } from "./styles"
import CategoryModal from "./category-modal"
import Card from "./card"

const AllAccessCategories = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const classes = useStaticQuery(graphql`
    query {
      allClass {
        nodes {
          instructors {
            name
          }
          categories
          availableForPurchase
          active
          id
          classId
          image
          includeInUnlock
          instructorByline
          shortDescription
          price
          totalDuration
          title
          unlock
          url
        }
      }
    }
  `)
  const filteredClasses = classes.allClass.nodes.filter(
    (c) => c.availableForPurchase && c.includeInUnlock,
  )
  const classMap = filteredClasses ? groupClasses(filteredClasses) : null

  return (
    <>
      <MainContainer>
        <HeadingContent>
          <h1>Classes Included</h1>
          <p>This special offer includes lifetime access to all 65 classes in the mbg library.*</p>
        </HeadingContent>
        <Grid
          numColumns={{ default: 3, desktopL: 3, desktop: 3, tablet: 2, mobile: 1 }}
          rowMargin="1rem"
          colMargin="1rem"
          padding="1rem"
        >
          {Object.keys(data).map((category) => (
            <Card
              key={category}
              title={category}
              category={data[category]}
              numClasses={classMap[category].length}
              triggerModal={() => {
                setIsOpen(true)
                setSelectedCategory(category)
              }}
            />
          ))}
        </Grid>
      </MainContainer>
      <CategoryModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        featured={data[selectedCategory]?.featuredClasses}
        classes={classMap[selectedCategory]}
        title={selectedCategory}
      />
    </>
  )
}

export default AllAccessCategories
